import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";

import mapPlaceholder from "../../../../assets/images/map-placeholder.png";
import { selectWebsiteTheme } from "../../../../store/slices/website";

import { Container, Text, MapContainer } from "./styled";

const Map = ({ address }) => {
  const { t } = useTranslation();
  const { colors } = useSelector(selectWebsiteTheme);
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  });

  const position = React.useMemo(() => ({
    lat: address?.latitude || 0,
    lng: address?.longitude || 0,
  }), [address]);

  const TextAddress = () => {
    if (!address) {
      return null;
    }

    return (
      <>
        <h3>{t("address", "Address")}</h3>
        <Text>
          {address.address1}
          ,
          <br /> {address.city}, {address.state_name}, {address.country_name}
        </Text>
      </>
    );
  };

  return (
    <Container>
      <TextAddress />
      <MapContainer src={mapPlaceholder} bgColor={colors[2].color}>
        {position.lat || position.lng ? (
          <>
            {isLoaded ? (
              <GoogleMap
                mapContainerStyle={{ width: "100%", height: "100%" }}
                center={position}
                zoom={12}
              >
                <Marker position={position} />
              </GoogleMap>
            ) : (
              <span>{t("map_loading", "Map is loading...")}</span>
            )}
          </>
        ) : (
          <span>{t("map_placeholder", "Map preview not available")}</span>
        )}
      </MapContainer>
    </Container>
  );
};

Map.propTypes = {
  address: PropTypes.object,
};

Map.defaultProps = {
  address: null,
};

export default Map;
